<!--      制冷系统        -->

<template>
  <div class="system_cool">
    <el-container>
      <el-header>
        <h2>制冷系统</h2>
      </el-header>
      <section>
        <div id="main1" v-cloak>
          <div id="load" v-if="show_load">
            <div id="loading-wrapper">
              <div id="loading-text">LOADING</div>
              <div id="loading-content"></div>
            </div>
          </div>
          <div id="energyMap">
            <div class="dynamic-freezer">
              <img src="../../assets/img/cool/cool_test.png" class="ims" />
              <div class="isOpen-first"></div>
              <div
                v-for="(item,index) in freezer_infoMore"
                :key="index"
                :class="'mch-'+index"
              >
              <div v-if="freezer_view[index].show">
                <div v-if="freezer_view[index].isOpen">
                  <img src="../../assets/img/cool/coo_add.png" style="width:100%;height: 5rem" />
                </div>
                <div v-else>
                  <img src="../../assets/img/cool/coo_close.png" style="width:100%;height: 5rem" />
                </div>
              </div>
              </div>
            </div>

            <div class="ims">
              <div class="freezer-0" title="关闭状态"></div>
              <div
                v-for="(item,index) in freezer_view"
                @click="getCh(freezer_info[index].name,index)"
                :class="'freezer-'+(index+1)"
                :key="index"
              ></div>
              <div class="pump_1" @click="showPump(1)"></div>
              <div class="pump_2" @click="showPump(2)"></div>
              <div class="pump_3" @click="showPump(3)"></div>
              <div class="pump_4" @click="showPump(4)"></div>
              <div class="pump_5" @click="showPump(5)"></div>
              <div class="pump_6" @click="showPump(6)"></div>
              <div class="pump_7" @click="showPump(7)"></div>
              <div class="pump_8" @click="showPump(8)"></div>
            </div>
            <!--冷冻机弹出面板-->
            <div class="pop-freezer" v-show="freezer_visible">
              <div class="pop-title">
                {{freezer_info[current_freezer.index].name}}
                <span
                  class="el-icon-close"
                  @click="info_close"
                ></span>
              </div>
              <div class="pop-center">
                <ul class="pop-left">
                  <li class="control">控制</li>
                  <li class="c1 pump-close">
                    <!-- class="{ gre1: butc_Color }"-->
                    <el-button
                      type="primary"
                      size="medium"
                      @click="openFreezer(freezer_info[current_freezer.index].name)"
                      :title="$store.state.user_info.info.grade == 3 ? '' : '您没有操作权限！'"
                      :disabled="$store.state.user_info.info.grade == 3 ? false : true"
                      round
                    >开</el-button>
                  </li>
                  <li>
                    <img
                      src="../../assets/img/cool/switch.png"
                      class="switch-img"
                      v-show="show_status_open"
                    />
                    <img
                      src="../../assets/img/cool/switch-close.png"
                      class="switch-img"
                      v-show="show_status_close"
                    />
                  </li>
                  <li class="c1 pump-open">
                    <!-- :class="{ gre4: buto_Color }"-->
                    <el-button
                      type="primary"
                      size="medium"
                      @click="closeFreezer(freezer_info[current_freezer.index].name)"
                      :title="$store.state.user_info.info.grade == 3 ? '' : '您没有操作权限！'"
                      :disabled="$store.state.user_info.info.grade == 3 ? false : true"
                      round
                    >关</el-button>
                  </li>
                  <li class="refrimg">
                    <img id="cool_img" src="../../assets/img/cool/refrigerator.png" />
                  </li>
                </ul>
                <ul class="pump-tab2">
                  <li>
                    <span class="r1">吸气温度：</span>
                    <span
                      class="right-info n12"
                    >{{freezer_info[current_freezer.index].YSJXQWD/10 || feezer_info_mock.YSJXQWD}}</span>
                  </li>
                  <li>
                    <span class="r1">排气温度：</span>
                    <span
                      class="right-info n1"
                    >{{freezer_info[current_freezer.index].YSJPQWD/10 || feezer_info_mock.YSJPQWD}}</span>
                  </li>
                  <li>
                    <span class="r1">压缩机 RLA 百分比：</span>
                    <span
                      class="right-info n2"
                    >{{freezer_info[current_freezer.index].YSJRLABFB/10 || feezer_info_mock.YSJRLABFB}}</span>
                  </li>
                  <li>
                    <span class="r1">供油压力：</span>
                    <span
                      class="right-info n3"
                    >{{freezer_info[current_freezer.index].GYYL/10 || feezer_info_mock.GYYL}}</span>
                  </li>
                  <li>
                    <span class="r1">油槽压力：</span>
                    <span
                      class="right-info numberhour n4"
                    >{{freezer_info[current_freezer.index].YCYL/10 || feezer_info_mock.YCYL}}</span>
                  </li>
                  <li>
                    <span class="r1">供油温度：</span>
                    <span
                      class="right-info n5"
                    >{{freezer_info[current_freezer.index].GYWD/10 || feezer_info_mock.GYWD}}</span>
                  </li>
                  <li>
                    <span class="r1">油槽温度：</span>
                    <span
                      class="right-info numberhour n6"
                    >{{freezer_info[current_freezer.index].YCWD/10 || feezer_info_mock.YCWD}}</span>
                  </li>
                  <li>
                    <span class="r1">出水温度设定点：</span>
                    {{freezer_info[current_freezer.index].ZLSZD/10 || feezer_info_mock.ZLSZD}}
                  </li>
                  <li>
                    <div class="xpress">
                      <span>蒸发器</span>
                    </div>
                    <div class="r2">
                      <div>
                        <span class="right-info2">出水：</span>
                        <span
                          class="right-info1 n8"
                        >{{freezer_info[current_freezer.index].YSJDZFQCSWD/10 || feezer_info_mock.YSJDZFQCSWD}}</span>
                      </div>
                      <div>
                        <span class="right-info2">进水：</span>
                        <span
                          class="right-info1 n9"
                        >{{freezer_info[current_freezer.index].ZFQJSWD/10 || feezer_info_mock.ZFQJSWD}}</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="xpress">
                      <span>冷凝器</span>
                    </div>
                    <div class="r2">
                      <div>
                        <span class="right-info2">出水：</span>
                        <span
                          class="right-info1 n10"
                        >{{freezer_info[current_freezer.index].LNQCSWD/10 || feezer_info_mock.LNQCSWD}}</span>
                      </div>
                      <div>
                        <span class="right-info2">进水：</span>
                        <span
                          class="right-info1 n11"
                        >{{freezer_info[current_freezer.index].LNQJSWD/10 || feezer_info_mock.LNQJSWD}}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!--冷却水泵面板-->
            <div class="pop-pump" v-show="pump_visible">
              <div class="pop-header">
                <div class="header-title">
                  <span>{{cooling_info.pump.title}}</span>
                  <span class="el-icon-close" @click="pump_visible = false"></span>
                </div>
              </div>
              <div class="pop-content">
                <ul class="pump-list">
                  <li>
                    <span class="r1">吸气温度：</span>
                    <span class="right-info n12">{{1}}</span>
                  </li>
                  <li>
                    <span class="r1">排气温度：</span>
                    <span class="right-info n1">{{1}}</span>
                  </li>
                  <li>
                    <span class="r1">压缩机 RLA 百分比：</span>
                    <span class="right-info n2">{{22}}</span>
                  </li>
                  <li>
                    <span class="r1">供油压力：</span>
                    <span class="right-info n3">{{1}}</span>
                  </li>
                  <li>
                    <span class="r1">油槽压力：</span>
                    <span class="right-info numberhour n4">{{22}}</span>
                  </li>
                  <li>
                    <span class="r1">供油温度：</span>
                    <span class="right-info n5">{{22}}</span>
                  </li>
                  <li>
                    <span class="r1">油槽温度：</span>
                    <span class="right-info numberhour n6">{{22}}</span>
                  </li>
                  <li>
                    <span class="r1">出水温度设定点：</span>
                    {{22}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </el-container>
  </div>
</template>

<script>
import io from "socket.io-client";
import { refreshing_token } from "../../api/http";
import { EncryptData } from "../../assets/js/common/encrypt";
import { base } from "../../api/index";
import { logout } from "../../api/http";
export default {
  name: "coolSys",
  data() {
    return {
      freezer_visible: false,
      pump_visible: false,
      ch2: {},
      freezer_view: [
        // 动态冷冻机视图及启停(预留10组，后面切割)
        { show: true, isOpen: false },
        { show: true, isOpen: false },
        { show: true, isOpen: false },
        { show: true, isOpen: false },
        { show: true, isOpen: false },
        { show: true, isOpen: false },
        { show: true, isOpen: false },
        { show: true, isOpen: false },
        { show: true, isOpen: false },
        { show: true, isOpen: false }
      ],
      freezer_info: [[]],
      feezer_info_mock: {
        YSJXQWD: 0,
        YSJPQWD: 0,
        YSJRLABFB: 0,
        GYYL: 0,
        YCYL: 0,
        GYWD: 0,
        YCWD: 0,
        ZLSZD: 0,
        YSJDZFQCSWD: 0,
        ZFQJSWD: 0,
        LNQCSWD: 0,
        LNQJSWD: 0
      },
      current_freezer: {
        index: 0,
        code: ""
      },
      freezer_infoMore: [],
      show_status_open: true,
      show_status_close: true,
      show_load: true,
      cooling_info: {
        pump: {
          title: "冷却水泵"
        }
      }
    };
  },
  created() {
    if (!localStorage.getItem("制冷系统")) {
      alert("该用户名没有制冷系统");
    } else {
      this.getFreezerInfo();
    }
    this.generateDfault();
  },
  watch: {
    freezer_visible: function(val) {
      val ? (this.pump_visible = false) : "";
    },
    pump_visible: function(val) {
      val ? (this.freezer_visible = false) : "";
    }
  },
  methods: {
    getFreezerInfo() {
      let _this = this;
      window.w = io.connect(base.offline + "/system/equipment");
      let token = localStorage.getItem("access_token");
      window.w.on("connect", function() {
        window.w.emit("system_equip", {
          room_name: "system_equip_data_chiller",
          system_id: localStorage.getItem("制冷系统"),
          jwt: token
        });
      });
      window.w.on("system_equip_response", function(message) {
        if (message.flag === 1) {
          _this.freezer_info = message.data;
          let length = message.data.length;
          _this.freezer_infoMore = JSON.parse(JSON.stringify(message.data));
          // _this.freezer_infoMore.splice(0,1);
          if (length > 10) {
            for (let i = 0; i < length - 2; i++) {
              _this.freezer_view.push({ show: true, isOpen: false });
            }
          } else {
            _this.freezer_view.splice(length);
          }
          _this.show_load = false;
          _this.freezer_info.forEach((item, index) => {
            if (item.JZKGZT == 1 && item.JZZT == 2) {
              _this.$set(_this.freezer_view[index], "isOpen", true);
            }
          });
        } else {
          // token过期的处理
          logout();
          // _this.$message.info('token认证过期，即将刷新');
          // refreshing_token();
          // setTimeout(function(){
          //   window.w.reconnect();
          // },1500);
        }
      });
    },
    getCh(code, index) {
      if (isNaN(this.freezer_view[index].isOpen)) {
        this.$message({
          showClose: true,
          message: code + "没有开启",
          type: "warning",
          duration: 1500
        });
      } else {
        this.freezer_visible = true;
        this.$set(this.current_freezer, "code", code);
        this.$set(this.current_freezer, "index", index);
        if (
          this.freezer_info[index].JZKGZT == 0 &&
          this.freezer_info[index].JZZT == 0
        ) {
          this.show_status_close = true;
          this.show_status_open = false;
        } else if (
          this.freezer_info[index].JZKGZT == 1 &&
          this.freezer_info[index].JZZT == 2
        ) {
          this.show_status_open = true;
          this.show_status_close = false;
        } else {
          this.show_status_open = false;
          this.show_status_close = true;
        }
      }
    },
    showPump(index) {
      //只渲染数据
      this.pump_visible = true;
      this.cooling_info.pump.title =
        this.cooling_info.pump.title.substr(0, 4) + index;
      switch (index) {
        case 1:
          renderData(index);
      }
      function renderData(code) {
        //根据机器码，渲染相应的数据。
      }
    },
    info_close() {
      this.freezer_visible = false;
    },
    openFreezer(f_code) {
      const _this = this;
      _this
        .$confirm("您确定要开启冷冻机 " + f_code, "提示")
        .then(() => {
          _this.$api.systemCool
            .openFreezer(f_code, EncryptData({}))
            .then(res => {
              if (res.data.flag === 1) {
                _this.$message.success("冷冻机 " + f_code + " 已开启！");
                _this.info_close();
                _this.getFreezerInfo();
              }
            });
        })
        .catch(() => {
          _this.$message.info("已取消操作！");
        });
    },
    closeFreezer(f_code) {
      const _this = this;
      this.$confirm("你确定要关闭冷冻机 " + f_code, "提示")
        .then(() => {
          this.$api.systemCool
            .openFreezer(f_code, EncryptData({}))
            .then(res => {
              if (res.data.flag === 1) {
                _this.$message.success("冷冻机 " + f_code + " 已关闭！");
                _this.info_close();
                _this.getFreezerInfo();
              }
            });
        })
        .catch(() => {
          _this.$message.info("已取消操作！");
        });
    },
    generateDfault() {
      Object.assign(this.feezer_info_mock, {
        YSJXQWD: this.getRandomVal(30, 35),
        YSJPQWD: this.getRandomVal(27, 31),
        YSJRLABFB: this.getRandomVal(20, 110),
        GYYL: this.getRandomVal(370, 410),
        YCYL: this.getRandomVal(370, 400),
        GYWD: this.getRandomVal(30, 40),
        YCWD: this.getRandomVal(45, 55),
        ZLSZD: 7.7,
        YSJDZFQCSWD: this.getRandomVal(10, 15),
        ZFQJSWD: this.getRandomVal(8, 11),
        LNQCSWD: this.getRandomVal(25, 30),
        LNQJSWD: this.getRandomVal(25, 30)
      });
    },
    getRandomVal(bottom = 0, top = 10) {
      return (Math.random() * (top - bottom) + bottom).toFixed(2);
    }
  },
  beforeRouteLeave(to, from, next) {
    window.w.close();
    next();
  }
};
</script>

<style lang="scss">
.system_cool {
  .el-header {
    margin-bottom: 1rem;
    height: 2rem !important;
    background-color: unset;

    h2 {
      margin: 1rem auto;
      width: 40%;
      height: 80%;
      text-align: center;
      line-height: 100%;
      font-size: 1rem;
      letter-spacing: 2rem;
      border-bottom: 1px skyblue dashed;
      color: orange;
    }
  }

  section {
    #energyMap {
      /*冷冻机*/
      .dynamic-freezer {
        .isOpen-first {
          position: absolute;
          top: 46.2%;
          left: 52.7%;
          width: 3.5%;
          height: 1.5%;
          background: #100;
          border-radius: 2px;
        }
        div[class^="mch"] {
          position: absolute;
          left: 44%;
          width: 20.47%;
        }
        .mch-0 {
          top: 47%;
        }
        .mch-1 {
          top: 60%;
        }
        .mch-2 {
          top: 72%;
        }
        .mch-3 {
          top: 84%;
        }
        .mch-4 {
          top: 90%;
        }
        .mch-5 {
          top: 90%;
        }
        .mch-6 {
          top: 90%;
        }
      }
      .pop-freezer {
        width: 43%;
        background-color: rgba(0, 0, 0, 0.8);
        position: absolute;
        min-width: 650px;
        top: 19%;
        left: 5%;
        right: 0;
        margin: auto;
        border-bottom: 10px solid rgba(0, 0, 0, 0.68);
        border-radius: 15px;
        z-index: 1002;
        opacity: 0.93;
        .pop-title {
          padding: 0.5rem;
          border-bottom: 1px solid #3155ae91;

          .el-icon-close {
            float: right;
            font-size: 0.6rem;
            &:hover {
              color: #aaa;
            }
            transform: scale(1.1);
          }
        }
        .switch-img {
          width: 20%;
        }
        ul {
          font-size: 1vw;
          list-style: none;
          width: 49%;
          display: inline-block;

          li {
            margin-top: 6%;
            width: 100%;

            #cool_img {
              width: 85%;
            }
          }

          .refrimg {
            margin-top: 19%;
          }
        }
        .pop-left {
          .c1 {
            width: 100%;
            text-align: center;

            .el-button.is-round {
              border-radius: 0.5rem;
              padding: 0.3rem 1.3rem;
            }
          }
        }
        .pump-tab2 {
          display: inline-block;
          vertical-align: top;
          width: 38%;
          span {
            display: inline-block;
          }
          li {
            margin-top: 6%;
            text-align: left;
            &:nth-child(odd) {
              background: linear-gradient(
                to left,
                rgba(200, 200, 200, 0.05),
                rgba(0, 0, 0, 0)
              );
            }
            &:nth-child(even) {
              background: linear-gradient(
                to right,
                rgba(200, 200, 200, 0.05),
                rgba(0, 0, 0, 0)
              );
            }
            .xpress {
              width: 44%;
              display: inline-block;
              vertical-align: 0.5rem;
            }
            .r2 {
              width: 50%;
              display: inline-block;
              .right-info2 {
                margin-top: 0.3rem;
              }
            }
          }
        }
      }
      .pop-pump {
        width: 43%;
        background-color: rgba(0, 0, 0, 0.8);
        position: absolute;
        min-width: 650px;
        top: 13%;
        left: 0;
        right: 0;
        margin: auto;
        border-bottom: 10px solid rgba(0, 0, 0, 0.68);
        border-radius: 15px;
        z-index: 1002;
        opacity: 0.93;
        /*display: none;*/
        .pop-header {
          .header-title {
            position: relative;
            width: 100%;
            text-align: center;
            color: darkgreen;
            span:first-child {
              display: inline-block;
              margin-left: 0;
              width: 76%;
              text-align: center;
              border-bottom: 1px solid rgba(200, 200, 200, 0.6);
            }
            span:last-child {
              position: absolute;
              top: 0.4rem;
              right: 0.5rem;
              font-size: 0.4rem;
              color: #fff;
              &:hover {
                color: lightblue;
                font-size: 0.5rem;
              }
            }
          }
        }
        .pop-content {
          width: 100%;
          ul.pump-list {
            margin-top: 0.5rem;
            li {
              height: 2rem;
              font-size: 0.8rem;
              line-height: 2rem;
            }
            li:nth-child(odd) {
              background: linear-gradient(
                to left,
                rgba(200, 200, 200, 0.05),
                rgba(0, 0, 0, 0)
              );
            }
            li:nth-child(even) {
              background: linear-gradient(
                to right,
                rgba(200, 200, 200, 0.05),
                rgba(0, 0, 0, 0)
              );
            }
          }
        }
      }
      .ims {
        width: 73%;
        position: absolute;
        top: 21%;
        left: 17%;
        height: 63%;
        div[class^="freezer"] {
          position: absolute;
          left: 47%;
          width: 9.4%;
          height: 12%;
          cursor: pointer;
          z-index: 1000;
        }
        .freezer-0 {
          top: 32.7%;
        }
        .freezer-1 {
          top: 52.5%;
        }
        .freezer-2 {
          top: 72.8%;
        }
        .freezer-3 {
          top: 93%;
        }
        .freezer-4 {
          top: 113.2%;
        } /*多的为预留*/
        .freezer-5 {
          top: 47%;
        }
        .freezer-6 {
          top: 47%;
        }
        .freezer-7 {
          top: 47%;
        }
        div[class^="pump"] {
          position: absolute;
          width: 4.7%;
          height: 13%;
          cursor: pointer;
        }
        .pump_1 {
          top: 44%;
          left: 25%;
        }
        .pump_2 {
          top: 57.5%;
          left: 25%;
        }
        .pump_3 {
          top: 71%;
          left: 25%;
        }
        .pump_4 {
          top: 84.2%;
          left: 25%;
        }
        .pump_5 {
          top: 44%;
          left: 76.8%;
        }
        .pump_6 {
          top: 57.5%;
          left: 76.8%;
        }
        .pump_7 {
          top: 71%;
          left: 76.8%;
        }
        .pump_8 {
          top: 84.2%;
          left: 76.8%;
        }
      }
    }
    #load {
      width: 95.8%;
      height: 85.2%;
      background-color: #0c1c2e !important;
      z-index: 1;
      /*loading*/
      #loading-wrapper {
        position: fixed;
        height: 89px;
        left: 47%;
        top: 38%;
      }
      #loading-text {
        display: block;
        position: absolute;
        top: 50%;
        left: 59%;
        color: #25f873;
        width: 100px;
        height: 30px;
        margin: -7px 0 0 -45px;
        text-align: center;
        font-family: "PT Sans Narrow", sans-serif;
        font-size: 20px;
      }
      #loading-content {
        display: block;
        position: relative;
        left: 59%;
        top: 50%;
        width: 170px;
        height: 170px;
        margin: -85px 0 0 -85px;
        border: 3px solid #f00;
      }
      #loading-content:after {
        content: "";
        position: absolute;
        border: 3px solid #0f0;
        left: 15px;
        right: 15px;
        top: 15px;
        bottom: 15px;
      }
      #loading-content:before {
        content: "";
        position: absolute;
        border: 3px solid #00f;
        left: 5px;
        right: 5px;
        top: 5px;
        bottom: 5px;
      }
      #loading-content {
        border: 3px solid transparent;
        border-top-color: #fa4176;
        border-bottom-color: #fa4176;
        border-radius: 50%;
        -webkit-animation: loader 2s linear infinite;
        -moz-animation: loader 2s linear infinite;
        -o-animation: loader 2s linear infinite;
        animation: loader 2s linear infinite;
      }
      #loading-content:before {
        border: 3px solid transparent;
        border-top-color: #fded76;
        border-bottom-color: #fded76;
        border-radius: 50%;
        -webkit-animation: loader 3s linear infinite;
        -moz-animation: loader 2s linear infinite;
        -o-animation: loader 2s linear infinite;
        animation: loader 3s linear infinite;
      }
      #loading-content:after {
        border: 3px solid transparent;
        border-top-color: #0ce6f7;
        border-bottom-color: #0ce6f7;
        border-radius: 50%;
        -webkit-animation: loader 1.5s linear infinite;
        animation: loader 1.5s linear infinite;
        -moz-animation: loader 2s linear infinite;
        -o-animation: loader 2s linear infinite;
      }
      @keyframes loader {
        0% {
          -webkit-transform: rotate(0deg);
          -ms-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
          -ms-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    }
  }
}
</style>
